export default "__VITE_ASSET__B827sPvm__"